import { render, staticRenderFns } from "./ExportToFile.vue?vue&type=template&id=35071e66"
import script from "./ExportToFile.vue?vue&type=script&lang=js"
export * from "./ExportToFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports